
import OnboardlistCategory from './OnboardlistCategory'
import OnbordingList from './OnbordingList'

const routes = [
  {
    type: 'collapse',
    key: 'OnboardlistCategory',
    route: '/',
    component: <OnboardlistCategory />,
  },
  {
    type: 'collapse',
    key: 'home',
    route: '/:page_id/:type',
    component: <OnbordingList />,
  },

]

export default routes
